import { render, staticRenderFns } from "./TableBaseComponent.vue?vue&type=template&id=4cc75e6c&scoped=true&"
import script from "./TableBaseComponent.vue?vue&type=script&lang=ts&"
export * from "./TableBaseComponent.vue?vue&type=script&lang=ts&"
import style0 from "./TableBaseComponent.vue?vue&type=style&index=0&id=4cc75e6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc75e6c",
  null
  
)

export default component.exports